(() => {
  const init = () => document.querySelectorAll('[data-km-header]').forEach((header) => {
    if (header.dataset.kmReady) return;
    header.dataset.kmReady = 'true';
    const lifecycle = new AbortController();
    const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal: lifecycle.signal });
    const toggle = header.querySelector('[data-km-toggle]');
    const mobile = header.querySelector('[data-km-mobile]');
    const backdrop = header.querySelector('[data-km-backdrop]');
    const disclosures = [...header.querySelectorAll('[data-km-desktop]')];
    const desktop = window.matchMedia('(min-width:1101px)');
    const hover = window.matchMedia('(hover:hover) and (pointer:fine)');
    let oldOverflow = null;
    let hoverTimer;
    const closeDesktop = (except) => disclosures.forEach((item) => { if (item !== except) item.open = false; });
    const positionMobile = () => header.style.setProperty('--km-top', `${Math.max(0, Math.round(header.querySelector('.kd-header').getBoundingClientRect().bottom))}px`);
    const closeMobile = (restoreFocus = false) => {
      if (mobile.hidden) return;
      mobile.hidden = true;
      backdrop.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', header.dataset.kmOpenLabel);
      if (oldOverflow !== null) { document.body.style.overflow = oldOverflow; oldOverflow = null; }
      if (restoreFocus) toggle.focus();
    };
    listen(toggle, 'click', () => {
      if (!mobile.hidden) return closeMobile(true);
      closeDesktop();
      positionMobile();
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      mobile.hidden = false;
      backdrop.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', header.dataset.kmCloseLabel);
      (mobile.querySelector('a') || mobile.querySelector('button') || toggle).focus({ preventScroll: true });
    });
    listen(backdrop, 'click', () => closeMobile(true));
    listen(mobile, 'click', (event) => { if (event.target.closest('a')) closeMobile(); });
    disclosures.forEach((item) => {
      listen(item, 'toggle', () => { if (item.open) closeDesktop(item); });
      listen(item, 'click', (event) => {
        // A pending hover action must never reverse the summary's native click toggle.
        clearTimeout(hoverTimer);
        if (event.target.closest('a')) closeDesktop();
      });
      listen(item, 'pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(hoverTimer);
        if (desktop.matches && hover.matches) hoverTimer = setTimeout(() => { closeDesktop(item); item.open = true; }, 100);
      });
      listen(item, 'pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(hoverTimer);
        if (hover.matches && !item.contains(document.activeElement)) hoverTimer = setTimeout(() => { item.open = false; }, 180);
      });
      listen(item, 'focusout', () => setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 0));
    });
    listen(document, 'click', (event) => { if (!header.contains(event.target)) { clearTimeout(hoverTimer); closeDesktop(); closeMobile(); } });
    listen(document, 'keydown', (event) => {
      if (event.key === 'Escape') {
        clearTimeout(hoverTimer);
        const open = disclosures.find((item) => item.open);
        if (open) { closeDesktop(); open.querySelector('summary').focus(); }
        closeMobile(true);
      }
      // Keep keyboard navigation within the open mobile navigation and its header controls.
      if (event.key === 'Tab' && !mobile.hidden) {
        const candidates = [...header.querySelectorAll('a, button, input:not([type="hidden"]), summary')].filter((el) => el.tabIndex >= 0 && el.getClientRects().length);
        const first = candidates[0];
        const last = candidates[candidates.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    listen(window, 'resize', () => {
      clearTimeout(hoverTimer);
      const focusedDisclosure = disclosures.find(item => item.contains(document.activeElement));
      if (desktop.matches) {
        const focusWasInMobile = !mobile.hidden && mobile.contains(document.activeElement);
        closeMobile();
        // The mobile toggle is hidden on desktop; return to the always-visible home link.
        if (focusWasInMobile) header.querySelector('.kd-logo')?.focus({ preventScroll: true });
      } else if (!mobile.hidden) positionMobile();
      closeDesktop();
      if (focusedDisclosure) {
        const focusTarget = desktop.matches ? focusedDisclosure.querySelector('summary') : toggle;
        focusTarget?.focus({ preventScroll: true });
      }
    }, { passive: true });
    listen(document, 'shopify:section:unload', (event) => { if (event.target.contains(header)) { clearTimeout(hoverTimer); closeMobile(); lifecycle.abort(); delete header.dataset.kmReady; } });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
